import React, { useEffect, useRef, useState } from 'react';
import jsQR from 'jsqr';
import { useNavigate } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
// import moment from 'moment';
import moment from 'moment-timezone';
import axios from 'axios';

let { lambda, appname } = window.app;

const ScannerComponent = ({ countsData, onScanChange, defaultstoreCounts }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const animationIdRef = useRef(null);
  const scanned = useRef(false);

  const navigate = useNavigate();
  const [scannedData, setScannedData] = useState(null);
  const [checkinData, setCheckinData] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [tableErrMsg1, setTableErrMsg1] = useState(false);
  const [invalidBarcode, setInvalidBarcode] = useState(false);
  const [scanCount, setScanCount] = useState(1);
  const [scanError, setScanError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [scanErrorMsg, setScanErrorMsg] = useState("Camera not Allowed Permission denied");
  // Camera could not be started (denied / missing / in use). Shows the inline
  // fallback panel in place of the video feed instead of an inescapable pop-up.
  const [cameraBlocked, setCameraBlocked] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    startScanner();
    return () => {
      isMountedRef.current = false;
      cancelAnimationFrame(animationIdRef.current);
      stopStream();
    };
  }, []);

  // SCRUM-358: location capacity is informational only and never blocks scanning.
  // Capacity status is surfaced by the green/orange/red indicator on the scan page,
  // so there is no capacity pop-up here.

  // Turn a getUserMedia rejection into something the user can act on. The browser
  // remembers a denial for the origin, so "denied" needs different wording (and a
  // different remedy) than "no camera on this device" or "another app has it".
  const getCameraErrorMessage = (error) => {
    const name = error?.name;

    if (name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError') {
      return "Camera access is blocked. Allow camera permission for this site in your browser settings, then try again.";
    }
    if (name === 'NotFoundError' || name === 'DevicesNotFoundError' || name === 'OverconstrainedError') {
      return "No camera was found on this device. Use the Walk-in button to check guests in manually.";
    }
    if (name === 'NotReadableError' || name === 'TrackStartError') {
      return "The camera is already in use by another app. Close it and try again.";
    }
    return "The camera could not be started. Please try again.";
  };

  const startScanner = async () => {
    onScanChange(false)
    try {
      if (!navigator.mediaDevices?.getUserMedia) {
        // Non-secure origin (plain http) or an unsupported browser: mediaDevices is undefined.
        const err = new Error('getUserMedia is not available');
        err.name = 'NotSupportedError';
        throw err;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
        audio: false,
      });

      // The user can navigate away while the permission prompt is open. Without this
      // the stream is assigned after unmount and the camera stays on.
      if (!isMountedRef.current) {
        stream.getTracks().forEach((track) => track.stop());
        return;
      }

      streamRef.current = stream;
      setCameraBlocked(false);
      setScanError(false);

      if (videoRef.current) {
        videoRef.current.srcObject = streamRef.current;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play();
          animationIdRef.current = requestAnimationFrame(scan);
        };
      }
    } catch (error) {
      console.error('Camera error:', error);
      if (!isMountedRef.current) return;
      setScanErrorMsg(getCameraErrorMessage(error));
      setCameraBlocked(true);
      setScanError(true);
    }
  };

  const stopStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  // const isBookingTimeNow = (bookingDateString) => {
  //   const now = new Date();
  //   const bookingDate = new Date(bookingDateString);
  //   let minutes = 15
  //   // Create range: 10 minutes before and after
  //   const MinutesBefore = new Date(now.getTime() - minutes * 60 * 1000);
  //   const MinutesAfter = new Date(now.getTime() + minutes * 60 * 1000);

  //   return bookingDate >= MinutesBefore && bookingDate <= MinutesAfter;
  // };



  const scan = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (video && canvas && video.videoWidth > 0 && video.videoHeight > 0) {
      const ctx = canvas.getContext('2d');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const code = jsQR(imageData.data, canvas.width, canvas.height);


      // if (code && !scanned.current && code?.data) {
      //   scanned.current = true;

      //   try {
      //     const parsedUrl = new URL(code?.data);
      //     const searchParams = new URLSearchParams(parsedUrl.search);
      //     const bookingId = searchParams.get("bookingId");
      //     const guestId = searchParams.get("guestId");
      //     const token = localStorage.getItem("token");
      //     const storeid = localStorage.getItem("storeid");

      //     // console.log("parsedUrl ", parsedUrl)

      //     if (!storeid) {
      //       setTableErrMsg(true);
      //       return;
      //     }

      //     const response = await axios.get(
      //       `${lambda}/bookingDetails?appname=${appname}&bookingId=${bookingId}&guestId=${guestId}&token=${token}`
      //     );
      //     // console.log("response?.data?.result?.[0] ", response?.data?.result?.[0])
      //     const booking = response?.data?.result?.[0] || [];
      //     // console.log("booking ", booking)
      //     if (booking && booking.length == 0) {
      //       setInvalidBarcode(true);
      //       return;
      //     }

      //     if (storeid.trim() !== booking.storeid?.trim()) {
      //       setTableErrMsg1(true);
      //       return;
      //     }

      //     cancelAnimationFrame(animationIdRef.current);
      //     stopStream();

      //     const getNextDateFromDay = (dayName, referenceDate = new Date()) => {
      //       const daysMap = {
      //         SUNDAY: 0,
      //         MONDAY: 1,
      //         TUESDAY: 2,
      //         WEDNESDAY: 3,
      //         THURSDAY: 4,
      //         FRIDAY: 5,
      //         SATURDAY: 6
      //       };

      //       const targetDay = daysMap[dayName.toUpperCase()];
      //       if (targetDay === undefined) throw new Error("Invalid day name");

      //       const refDay = referenceDate.getDay();
      //       let diff = targetDay - refDay;

      //       if (diff < 0) {
      //         diff += 7; // Get next week's day if today is past the target day
      //       }

      //       // If you want to include today when it matches, remove this check:
      //       // if (diff === 0) diff = 7;

      //       const nextDate = new Date(referenceDate);
      //       nextDate.setDate(referenceDate.getDate() + diff);

      //       return nextDate.toISOString().split('T')[0]; // Returns YYYY-MM-DD
      //     }

      //     // const isBookingInCheckinWindow = (bookingDate, spotStartTime, timeZone) => {
      //     //   // Normalize booking date to store timezone
      //     //   // const localBookingMoment = moment.tz(bookingDate, timeZone).startOf("day");
      //     //   const localBookingMoment = moment.utc(bookingDate).tz(timeZone);

      //     //   // Combine with spot time
      //     //   const spotMoment = moment.tz(
      //     //     `${localBookingMoment.format("YYYY-MM-DD")} ${spotStartTime}`,
      //     //     "YYYY-MM-DD hh:mm A",
      //     //     timeZone
      //     //   );

      //     //   const now = moment().tz(timeZone);
      //     //   const windowStart = spotMoment.clone().subtract(15, "minutes");
      //     //   // console.log("spotMoment ", spotMoment)
      //     //   const windowEnd = spotMoment.clone().add(10, "minutes");

      //     //   if (now.isBetween(windowStart, windowEnd)) {
      //     //     return { status: "VALID", message: "" };
      //     //   } else if (now.isBefore(windowStart)) {
      //     //     return {
      //     //       status: "TOO_EARLY",
      //     //       message: `There's still time for you to check in, your spot is scheduled for ${spotMoment.format("MM-DD-YYYY")} at ${spotMoment.format("hh:mm A")}.`
      //     //     };
      //     //   } else {
      //     //     return { status: "EXPIRED", message: "Booking Expired" };
      //     //   }
      //     // };


      //     const isBookingInCheckinWindow = (spotDate, spotStartTime, timeZone) => {
      //       // Create spot moment in store timezone
      //       const spotMoment = moment.tz(
      //         `${spotDate} ${spotStartTime}`,
      //         "YYYY-MM-DD hh:mm A",
      //         timeZone
      //       );

      //       // Make sure 'now' is also in the same timezone
      //       const now = moment().tz(timeZone);

      //       const windowStart = spotMoment.clone().subtract(15, "minutes");
      //       const windowEnd = spotMoment.clone().add(10, "minutes");

      //       // console.log("Now:", now.format());
      //       // console.log("Window Start:", windowStart.format());
      //       // console.log("Spot:", spotMoment.format());
      //       // console.log("Window End:", windowEnd.format());

      //       if (now.isBetween(windowStart, windowEnd)) {
      //         return { status: "VALID", message: "" };
      //       } else if (now.isBefore(windowStart)) {
      //         return {
      //           status: "TOO_EARLY",
      //           message: `There's still time for you to check in, your spot is scheduled for ${spotMoment.format("MM-DD-YYYY")} at ${spotMoment.format("hh:mm A")}.`
      //         };
      //       } else {
      //         return { status: "EXPIRED", message: "Booking Expired" };
      //       }
      //     };


      //     const day = booking?.day;
      //     const spotStartTime = booking?.spotstart;
      //     const bookingDateUTC = booking?.bookingDate;
      //     const timeZone = booking?.timeZone || "Asia/Kolkata";
      //     const nextDate = getNextDateFromDay(day);

      //     const bookingDateMoment = moment.tz(bookingDateUTC, timeZone);
      //     const nextDateMoment = moment.tz(nextDate, "YYYY-MM-DD", timeZone);

      //     // **BLOCK COMPLETED BOOKINGS FIRST**
      //     if (booking?.status === "COMPLETED") {
      //       booking["message"] = "Booking completed";
      //       setScannedData(booking);
      //       onScanChange(true);
      //       return;  // Stop further processing
      //     }
      //     if (booking?.message === "Guest Already Scanned") {
      //       booking["message"] = "Guest Already Scanned";
      //       setScannedData(booking);
      //       onScanChange(true);
      //       return;  // Stop further processing
      //     }
      //     if (booking?.status === "EXPIRED") {
      //       booking["message"] = "Booking expired";
      //       setScannedData(booking);
      //       onScanChange(true);
      //       return;  // Stop further processing
      //     }

      //     if (bookingDateMoment.isSame(nextDateMoment, 'day')) {
      //       const spotTimeMoment = moment.tz(`${nextDate} ${spotStartTime}`, "YYYY-MM-DD hh:mm A", timeZone);
      //       const checkinResult = isBookingInCheckinWindow(spotTimeMoment.clone(), spotStartTime, timeZone);

      //       booking["message"] = checkinResult.message;
      //     } else {
      //       const spotTimeMoment = moment.tz(`${nextDate} ${spotStartTime}`, "YYYY-MM-DD hh:mm A", timeZone);
      //       const checkinResult = isBookingInCheckinWindow(spotTimeMoment.clone(), spotStartTime, timeZone);

      //       booking["message"] = checkinResult.message;
      //     }

      //     setScannedData(booking);
      //     onScanChange(true);

      //   } catch (error) {
      //     console.error("Error fetching booking details:", error);
      //     setInvalidBarcode(true);
      //     return;
      //   }
      // }




      if (code && !scanned.current && code?.data) {
        scanned.current = true;

        try {
          const parsedUrl = new URL(code?.data);
          const searchParams = new URLSearchParams(parsedUrl.search);
          const bookingId = searchParams.get("bookingId");
          const guestId = searchParams.get("guestId");
          const token = localStorage.getItem("token");
          const storeid = localStorage.getItem("storeid");

          // console.log("parsedUrl ", parsedUrl);

          if (!storeid) {
            setTableErrMsg(true);
            return;
          }

          const response = await axios.get(
            `${lambda}/bookingDetails?appname=${appname}&bookingId=${bookingId}&guestId=${guestId}&token=${token}`
          );

          const booking = response?.data?.result?.[0];
          console.log("booking ", booking);
          if (!booking) {
            setInvalidBarcode(true);
            return;
          }

          if (storeid.trim() !== booking.storeid?.trim()) {
            setTableErrMsg1(true);
            return;
          }

          setScanCount(booking?.scanCount + 1 || 1);
          cancelAnimationFrame(animationIdRef.current);
          stopStream();

          // ----------------------------------------
          // 🔹 Helper Functions
          // ----------------------------------------


          // ----------------------------------------
          // 🔹 Booking Check-in Window Validation
          // ----------------------------------------
          // const isBookingInCheckinWindow = (spotDate, spotStartTime, timeZone) => {
          //   const spotMoment = moment.tz(
          //     `${spotDate} ${spotStartTime}`,
          //     "YYYY-MM-DD hh:mm A",
          //     timeZone
          //   );

          //   const now = moment().tz(timeZone);
          //   const windowStart = spotMoment.clone().subtract(15, "minutes");
          //   const windowEnd = spotMoment.clone().add(10, "minutes");

          //   // console.log("Now:", now.format());
          //   // console.log("Window Start:", windowStart.format());
          //   // console.log("Spot:", spotMoment.format());
          //   // console.log("Window End:", windowEnd.format());

          //   if (now.isBetween(windowStart, windowEnd)) {
          //     return { status: "VALID", message: "" };
          //   } else if (now.isBefore(windowStart)) {
          //     return {
          //       status: "TOO_EARLY",
          //       message: `There's still time for you to check in, your spot is scheduled for ${spotMoment.format(
          //         "MM-DD-YYYY"
          //       )} at ${spotMoment.format("hh:mm A")}.`,
          //     };
          //   } else {
          //     return { status: "EXPIRED", message: "Booking Expired" };
          //   }
          // };

          const isBookingInCheckinWindow = (spotDate, spotStartTime, timeZone) => {
            // Accept both "hh:mm A" and "h:mm A" and 24-hour just-in-case
            const formatCandidates = ["YYYY-MM-DD hh:mm A", "YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"];
            let spotMoment = null;

            for (const fmt of formatCandidates) {
              const m = moment.tz(`${spotDate} ${spotStartTime}`, fmt, timeZone);
              if (m.isValid()) {
                spotMoment = m;
                break;
              }
            }

            if (!spotMoment) {
              console.error("Unable to parse spot datetime:", spotDate, spotStartTime, timeZone);
              return { status: "ERROR", message: "Invalid spot date/time format" };
            }

            const now = moment().tz(timeZone);
            // Only the "too early" side is decided here, using the store's Early Check-In
            // Allowance. Expiry AFTER the spot time belongs to the API, which applies the
            // store's Check-In Code Expiration and is handled before this runs. A second
            // local rule here (a hardcoded 10 min) is what made the scanner report expired
            // while My Spots and the dashboard still showed the spot as active.
            let earlyCheckInWindow = booking?.storeInfo?.earlyCheckInWindow || 15;
            const windowStart = spotMoment.clone().subtract(earlyCheckInWindow, "minutes");

            if (now.isBefore(windowStart)) {
              return {
                status: "TOO_EARLY",
                message: `There's still time for you to check in, your spot is scheduled for ${spotMoment.format(
                  "MM-DD-YYYY"
                )} at ${spotMoment.format("hh:mm A")}.`,
              };
            }

            return { status: "VALID", message: "" };
          };


          // ----------------------------------------
          // 🔹 Prepare Data
          // ----------------------------------------
          const timeZone = booking?.timeZone || "America/Los_Angeles";
          const spotStartTime = booking?.spotstart;
          // const bookingDateUTC = booking?.bookingDate;
          // const bookingDate = moment(bookingDateUTC).tz(timeZone).format("YYYY-MM-DD");
          // bookingDate already has timezone info like "2025-10-28T23:50:00.000-07:00"
          // Ensure we parse the bookingDate in the booking's timezone to avoid date shifts
          const bookingDateLocal = moment.tz(booking.bookingDate, timeZone);
          const bookingDate = bookingDateLocal.format("YYYY-MM-DD");

          // ----------------------------------------
          // 🔹 Handle Booking Status
          // ----------------------------------------
          if (booking?.status === "ACTIVE" && booking?.guests?.[0]?.status == "EXPIRED") {
            booking["message"] = `Your scanner has expired`;
            setScannedData(booking);
            onScanChange(true);
            return;
          }

          if (booking?.status === "COMPLETED") {
            booking["message"] = "Booking completed";
            if (booking?.guests?.[0]?.status == "EXPIRED") {
              booking["message"] = `Booking completed and your scanner has expired`;
            }
            setScannedData(booking);
            onScanChange(true);
            return;
          }

          if (booking?.message === "Guest Already Scanned") {
            booking["message"] = "Guest Already Scanned";
            setScannedData(booking);
            onScanChange(true);
            return;
          }

          // The API applies the store's Check-In Code Expiration rule and returns its verdict
          // as "Booking Expired" in message. booking.status is read before that update is
          // written, so it can still say ACTIVE/PENDING on an expired spot — trust message too.
          if (booking?.status === "EXPIRED" || booking?.message === "Booking Expired") {
            booking["message"] = "Booking expired";
            setScannedData(booking);
            onScanChange(true);
            return;
          }

          // ----------------------------------------
          // 🔹 Check Check-in Time Window
          // ----------------------------------------
          const checkinResult = isBookingInCheckinWindow(
            bookingDate,
            spotStartTime,
            timeZone
          );

          booking["message"] = checkinResult.message;
          // Keep the computed window verdict on its own field. Overwriting booking.status
          // here would break the ACTIVE/COMPLETED screens in renderStatusUI that read it,
          // but without it the UI cannot tell "too early" from "expired".
          booking["checkinWindowStatus"] = checkinResult.status;
          // console.log("Check-in Result:", checkinResult);

          setScannedData(booking);
          onScanChange(true);
        } catch (error) {
          console.error("Error fetching booking details:", error);
          setInvalidBarcode(true);
          return;
        }
      }


    }

    animationIdRef.current = requestAnimationFrame(scan);
  };

  const scanAgain = (e) => {
    e.preventDefault();
    setSubmitted(false);
    setScannedData(null);
    scanned.current = false;
    startScanner();
    onScanChange(false)
  };

  const checkInAPI = async (item, type) => {
    const guestId = item?.guests?.[0]?.guestId;
    const token = localStorage.getItem("token");
    let storeid = localStorage.getItem("storeid");
    setIsLoading(true);
    const response = await axios.post(
      `${lambda}/updateScanBookings?appname=${appname}&type=${type}&guestId=${guestId}&token=${token}`
    );

    setCheckinData(response?.data?.result?.[0]);
    if (type == "checkIn") {
      setSubmitted(true);
      setIsLoading(false);
      // setScanCount(prev => prev + 1);
    } else {
      setSubmitted(false);
      setIsLoading(false);
      setScannedData(null);
      scanned.current = false;
      startScanner();
    }
    defaultstoreCounts(storeid);
  };

  // console.log("scannedData ", scannedData)
  // console.log("scanCount ", scanCount)
  const CenterWrapper = ({ children }) => (
    <div className="col-12">
      <div className="d-flex justify-content-center">
        <div
          className="scan-center-wrapper"
          style={{
            width: "400px",
            maxWidth: "100%"
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );


  // if (scannedData && !submitted) {
  //   let singleCount = (countsData?.walkin || 0) + (countsData?.visitorCount || 0);
  //   let scannedEqualCount = singleCount >= countsData?.maxVisitor;

  //   // console.log("scannedEqualCount ", scannedEqualCount, scannedData?.message, ',ss')

  //   return (
  //     <div id="scan-container">
  //       {(scannedData?.message) ? (
  //         <div id="scan-message-block">
  //           {scannedData?.message === "Guest Already Scanned" && scannedData?.guests?.[0]?.checkOutTime !== "" ? (
  //             <p id="checkout-completed-text" className="checkout-txt">
  //               Guest already checked out and spot was completed
  //             </p>
  //           ) : (
  //             <p id="scan-message-text" className="checkout-txt">{scannedData?.message}</p>
  //           )}

  //           {scannedData?.message === "Guest Already Scanned" && scannedData?.guests?.[0]?.checkOutTime === "" && (
  //             <p id="ready-checkout-text" className="checkout-txt">Ready to Check-out</p>
  //           )}

  //           <div className="col-md-12" id="scan-action-buttons">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="d-flex justify-content-center align-items-center">
  //                   <button id="scan-again-btn" className="stroke-btn-style me-3" onClick={scanAgain}>
  //                     SCAN AGAIN
  //                   </button>

  //                   {scannedData?.message === "Guest Already Scanned" && scannedData?.guests?.[0]?.checkOutTime === "" && (
  //                     <button
  //                       id="check-out-btn"
  //                       className="fill-btn-style"
  //                       onClick={() => checkInAPI(scannedData, 'checkOut')}
  //                     >
  //                       {isLoading ? (
  //                         <img
  //                           src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
  //                           className="loading-icon"
  //                           alt="Loading"
  //                           id="scan-loading-icon"
  //                         />
  //                       ) : null}
  //                       CHECK OUT
  //                     </button>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       ) : scannedEqualCount && scannedData?.message == "" ? (
  //         <div className="scan-card-container rounded" id="scan-success-card">
  //           <div className="header-part">
  //             <div className="d-flex align-items-center">
  //               <span className="material-symbols-outlined text-danger">block</span>
  //               <div className="text-part">
  //                 <h6 id="spot-saved-heading" className="s-heading">STORE IS FULL</h6>

  //               </div>
  //             </div>
  //           </div>

  //           <div className="col-md-12" id="checkin-action-buttons">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="d-flex justify-content-center align-items-center">
  //                   <button id="scan-again-btn-2" className="stroke-btn-style me-3" onClick={scanAgain}>
  //                     SCAN AGAIN
  //                   </button>

  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>) : (
  //         <div className="scan-card-container rounded" id="scan-success-card">
  //           <div className="header-part">
  //             <div className="d-flex align-items-center">
  //               <span className="material-symbols-outlined text-success">check_circle</span>
  //               <div className="text-part">
  //                 <h6 id="spot-saved-heading" className="s-heading">SPOT SAVED</h6>
  //                 <p id="party-size-text" className="text-muted">For party {scanCount} of {scannedData?.partySize}</p>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="body-part">
  //             <div className="mb-4">
  //               <p className="day-time-date">Time</p>
  //               <h6 id="spot-start-time" className="day-time-date-txt">{scannedData?.spotstart}</h6>
  //             </div>
  //             <div className="mb-3">
  //               <p className="day-time-date">Date</p>
  //               <h6 id="booking-date" className="day-time-date-txt">
  //                 {scannedData?.bookingDate ? moment(scannedData?.bookingDate).format("MM-DD-YYYY") : ""}
  //               </h6>
  //             </div>
  //           </div>
  //           <div className="col-md-12" id="checkin-action-buttons">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="d-flex justify-content-center align-items-center">
  //                   <button id="scan-again-btn-2" className="stroke-btn-style me-3" onClick={scanAgain}>
  //                     SCAN AGAIN
  //                   </button>
  //                   <button
  //                     id="check-in-btn"
  //                     className="fill-btn-style"
  //                     onClick={() => checkInAPI(scannedData, 'checkIn')}
  //                   >
  //                     {isLoading ? (
  //                       <img
  //                         src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
  //                         className="loading-icon"
  //                         alt="Loading"
  //                         id="scan-loading-icon"
  //                       />
  //                     ) : null}
  //                     CHECK IN
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       )}
  //     </div>

  //   );
  // }

  const renderStatusUI = () => {
    const status = scannedData?.status;
    const message = scannedData?.message;
    const guest = scannedData?.guests?.[0];
    const guestStatus = scannedData?.guests?.[0]?.status;
    const windowStatus = scannedData?.checkinWindowStatus;

    /* ---------------- TOO EARLY ---------------- */
    // Gate on the computed window verdict, not on booking.status. A booking nobody has
    // checked in yet is "PENDING" whether the scan is early or late, so keying off it
    // showed TOO EARLY for expired spots too.
    if (windowStatus === "TOO_EARLY") {
      return (
        <div className="success-container">
          <div className="success-card text-center p-0">
            <div className="px-4 pt-2">
              <div className="success-icon">
                <div className="early icon-ring">
                  <div className="early icon-inner">
                    {/* <span className="material-symbols-outlined">cancel</span> */}
                    <span class="material-symbols-outlined">
                      calendar_clock
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <h2 className="success-title">TOO EARLY</h2>
                {/* <p className="success-text">{message}</p> */}
                <p className="success-text">Based on your location preferences, it is too early to check this visitor in. They have a spot saved for:</p>
                <h4 className="party-text" style={{ fontWeight: "700" }}>
                  For party {scanCount} of {scannedData?.partySize}
                </h4>

                <span className="time-chip text-center">
                  {moment(scannedData?.bookingDate).format("MMM DD, YYYY")}
                  <span className="date-chip">{scannedData?.spotstart}</span>
                </span>
              </div>
            </div>

            {/* DIVIDER */}
            <div className="ticket-divider my-1">
              <span />
            </div>

            <div className="px-4">
              <div class="visitor-card-details">
                <div class="visitor-header justify-content-center">
                  <div class="visitor-icon">
                    <span
                      className="material-symbols-outlined avatar"
                      style={{ fontSize: "40px", marginBottom: "6px" }}
                    >
                      account_circle
                    </span>
                  </div>

                  <div class="visitor-info">
                    <div class="section-title">VISITOR</div>
                    <div class="visitor-name">{scannedData?.guests?.[0]?.name || scannedData?.name}</div>
                  </div>
                </div>
                <button className="fill-btn-style" onClick={scanAgain} style={{ marginTop: "24px" }}>
                  Scan Again
                </button>
              </div>
            </div>

          </div>
        </div>
      );
    }

    // /* ---------------- ACTIVE + GUEST EXPIRED ---------------- */
    if (status === "ACTIVE" && guestStatus === "EXPIRED") {
      return (
        <div className="success-container">
          <div className="success-card text-center">
            <div className="success-icon expired">
              <div className="expired icon-ring">
                <div className="expired icon-inner">
                  <span className="material-symbols-outlined">timer_off</span>

                </div>
              </div>

            </div>
            <h2 className="success-title">SCANNER EXPIRED</h2>
            <p className="success-text">
              Your scanner has expired.
            </p>
            <button className="fill-btn-style" onClick={scanAgain}>
              Scan Again
            </button>
          </div>
        </div>
      );
    }
    // /* ---------------- GUEST ALREADY SCANNED ---------------- */
    if (
      message === "Guest Already Scanned" &&
      guest?.checkOutTime !== ""
    ) {
      return (
        <div className="success-container">
          <div className="success-card text-center">
            <div className="success-icon checked-out">
              <div className="checked-out icon-ring">
                <div className="checked-out icon-inner">
                  <span className="material-symbols-outlined">exit_to_app</span>

                </div>
              </div>

            </div>
            <h2 className="success-title">ALREADY CHECKED OUT</h2>
            <p className="success-text">
              Visitor has already checked out and spot was completed
            </p>
            <button className="fill-btn-style" onClick={scanAgain}>
              Scan Next Visitor
            </button>
          </div>
        </div>
      );
    }
    if (
      message === "Guest Already Scanned" &&
      guest?.checkOutTime == ""
    ) {
      return (
        <div className="success-container">
          <div className="success-card text-center p-0">
            <div className="px-4 pt-2">
              <div className="success-icon check-out">
                <div className="check-out icon-ring">
                  <div className="check-out icon-inner">
                    <span class="material-symbols-outlined">
                      clock_loader_90
                    </span>

                  </div>
                </div>

              </div>
            </div>

            <div className="text-align-center">
              <h2 className="success-title">Visitor In Location</h2>
              <p className='fs-18 mt-3'>Is the Visitor ready to Check Out? </p>
              <h4 className="party-text" style={{ fontWeight: "700" }}>
                For party {scanCount - 1} of {scannedData?.partySize}
              </h4>

              <span className="time-chip text-center">
                {moment(scannedData?.bookingDate).format("MMM DD, YYYY")}
                <span className="date-chip">{scannedData?.spotstart}</span>
              </span>

              {/* DIVIDER */}
              <div className="ticket-divider my-1">
                <span />
              </div>

              {/* <div class="visitor-header">
                <div class="visitor-icon">
                  <span
                    className="material-symbols-outlined avatar"
                    style={{ fontSize: "40px", marginBottom: "6px" }}
                  >
                    account_circle
                  </span>
                </div>

                <div class="visitor-info">
                  <div class="section-title">VISITOR</div>
                  <div class="visitor-name">{scannedData?.guests?.[0]?.name || scannedData?.name}</div>
                </div>
              </div> */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  marginTop: "8px"
                }}
              >
                {/* ICON */}
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontSize: "42px",
                    color: "#6b7280"
                  }}
                >
                  account_circle
                </span>

                {/* TEXT */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#6b7280",
                      letterSpacing: "1px"
                    }}
                  >
                    VISITOR
                  </div>

                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "#374151",
                      lineHeight: "1.2"
                    }}
                  >
                    {scannedData?.guests?.[0]?.name || scannedData?.name}
                  </div>
                </div>
              </div>

              <div className="d-flex gap-3 justify-content-center mt-4 mb-3">
                <button
                  className="fill-btn-style"
                  onClick={scanAgain}
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#6C2BD9",
                    border: "2px solid #6C2BD9"
                  }}
                >
                  SCAN AGAIN
                </button>

                <button
                  className="fill-btn-style"
                  onClick={() => checkInAPI(scannedData, "checkOut")}
                  style={{
                    backgroundColor: "#6C2BD9",
                    color: "#FFFFFF",
                    border: "none"
                  }}
                >
                  {isLoading && (
                    <img
                      src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"
                      className="loading-icon"
                      style={{ marginRight: "6px" }}
                    />
                  )}
                  CHECK OUT
                </button>
              </div>
            </div>

          </div>
        </div>
      );
    }

    // /* ---------------- BOOKING EXPIRED ---------------- */
    // The API sets "Booking Expired" and the scan handler normalises it to "Booking expired";
    // match either casing so a late scan lands here instead of falling through.
    if (message?.toLowerCase() === "booking expired") {
      return (
        <div className="success-container">
          <div className="success-card text-center">
            <div className="success-icon">
              <div className="expired icon-ring">
                <div className="expired icon-inner">
                  <span className="material-symbols-outlined">cancel</span>
                </div>
              </div>
            </div>

            <h2 className="success-title">SPOT EXPIRED</h2>
            <p className="success-text">
              This spot has already expired.
            </p>

            <button className="fill-btn-style" onClick={scanAgain}>
              Scan Again
            </button>
          </div>
        </div>
      );
    }

    // /* ---------------- COMPLETED ---------------- */
    if (status === "COMPLETED") {
      return (
        <div className="success-container ">
          <div className="success-card text-center">
            <div className="success-icon">
              <div className="completed icon-ring">
                <div className="completed icon-inner">
                  <span className="material-symbols-outlined">check</span>
                </div>
              </div>
            </div>
            <h2 className="success-title">SPOT COMPLETED</h2>
            <p className="success-text">
              {guestStatus === "EXPIRED"
                ? "Spot completed and your scanner has expired."
                : "This spot has already been completed."}
            </p>
            <button className="fill-btn-style" onClick={scanAgain}>
              Scan Next Visitor
            </button>
          </div>
        </div>
      );
    }

    /* ---------------- DEFAULT ---------------- */
    return (
      <p className="checkout-txt text-center">
        {message}
      </p>
    );
  };


  if (scannedData && !submitted) {
    return (
      <CenterWrapper>

        {/* ---------- MESSAGE / ALREADY SCANNED ---------- */}
        {scannedData?.message ? (
          <div className="card full-height-card text-center">

            <div className="card-body spot-card">

              <p className="checkout-txt">
                {renderStatusUI()}
                {/* {scannedData?.message === "Guest Already Scanned" &&
                  scannedData?.guests?.[0]?.checkOutTime !== ""
                  ? "Guest already checked out and spot was completed"
                  :

                   //scannedData?.message?.toUpperCase()
                   scannedData?.message == "Booking expired" &&
                  <div className="success-container">
                    <div className="success-card text-center">
                      <div className="success-icon">
                       <div className="expired icon-ring">
                          <div className="expired icon-inner">
                            <span className="material-symbols-outlined">check</span>
                          </div>
                        </div>
                      </div>
                      <h2 className="success-title">{scannedData?.message?.toUpperCase()}</h2>
                      <p className="success-text">
                        Your spot has been expired.
                      </p>
                      <button className="fill-btn-style">
                        Scan Again
                      </button>
                    </div>
                  </div>

                } */}
              </p>

              {/* {scannedData?.message === "Guest Already Scanned" &&
                scannedData?.guests?.[0]?.checkOutTime === "" && (
                  <p className="checkout-txt">Ready to Check-out</p>
                )}

              <div className="d-flex justify-content-center gap-3 mt-4">
                <button className="stroke-btn-style" onClick={scanAgain}>
                  SCAN AGAIN
                </button>

                {scannedData?.message === "Guest Already Scanned" &&
                  scannedData?.guests?.[0]?.checkOutTime === "" && (
                    <button
                      className="fill-btn-style"
                      onClick={() => checkInAPI(scannedData, "checkOut")}
                    >
                      {isLoading && (
                        <img
                          src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"
                          className="loading-icon"
                        />
                      )}
                      CHECK OUT
                    </button>
                  )}
              </div> */}

            </div>
          </div>
        )

            /* ---------- SPOT SAVED ---------- */
            : (
              <div className="card full-height-card">
                <div className="card-body spot-card text-center">

                  {/* HEADER */}
                  <div className="spot-header justify-content-center">
                    <div className="d-flex flex-column align-items-center gap-2">

                      <span
                        className="material-symbols-outlined text-success"
                        style={{ fontSize: "28px" }}
                      >
                        check_circle
                      </span>

                      <h4 className="s-heading mb-0">SPOT SAVED</h4>

                      <h4 className="text-muted mb-2">
                        For party {scanCount} of {scannedData?.partySize}
                      </h4>

                      <span className="time-chip text-center">
                        {moment(scannedData?.bookingDate).format("MMM DD, YYYY")}
                        <span className="date-chip">{scannedData?.spotstart}</span>
                      </span>

                    </div>
                  </div>

                  {/* DIVIDER */}
                  <div className="ticket-divider my-1">
                    <span />
                  </div>

                  {/* VISITOR */}
                  {/* {scannedData?.guests?.[0]?.name && ( */}
                  <div class="visitor-section">
                    <div class="d-flex gap-3 align-items-center">
                      <span class="material-symbols-outlined avatar">account_circle</span>
                      <div className='text-left'>
                        <h6 class="section-title">VISITOR</h6>
                        <p class="visitor-name">{scannedData?.guests?.[0]?.name || scannedData?.name}</p>
                      </div>
                    </div>

                    {/* <div class="add-icon">
                      <span class="material-symbols-outlined">add_notes</span>
                    </div> */}
                  </div>
                  {/* )} */}
                  {/* Tags */}

                  {/* <h6 class="assign-title">Assign tag (Optional)</h6>

                  <div class="tag-card-body">
                    <div className="tag-card vip-card">
                      <h2 className="badge vip">VIP</h2>
                      <p>High-value guest who receives priority treatment</p>
                    </div>

                   
                    <div className="tag-card ">
                      <h2 className="badge watchlist">VIP</h2>
                      <p>High-value guest who receives priority treatment</p>
                    </div>

                    <div className="tag-card spender-card">
                      <h2 className="badge spender">VIP</h2>
                      <p>High-value guest who receives priority treatment</p>
                    </div>

                    <div className="tag-card press-card">
                      <h2 className="badge press">VIP</h2>
                      <p>High-value guest who receives priority treatment</p>
                    </div>

                    <div className="tag-card bottle-card">
                      <h2 className="badge bottle">VIP</h2>
                      <p>High-value guest who receives priority treatment</p>
                    </div>

                    <div className="tag-card ada-card">
                      <h2 className="badge ada">VIP</h2>
                      <p>High-value guest who receives priority treatment</p>
                    </div>

                  </div> */}
                  {/* ACTION */}
                  <div className="d-flex justify-content-center gap-3 mt-3 pb-4">
                    {/* SCAN AGAIN */}
                    <button
                      className="stroke-btn-style"
                      onClick={scanAgain}
                      disabled={isLoading}
                    >
                      SCAN AGAIN
                    </button>
                    {/* CHECK IN */}
                    <button
                      className="fill-btn-style"
                      onClick={() => checkInAPI(scannedData, "checkIn")}
                      disabled={isLoading}
                    >
                      {isLoading && (
                        <img
                          src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"
                          className="loading-icon me-2"
                          alt="loading"
                        />
                      )}
                      CHECK IN
                    </button>



                  </div>


                </div>
              </div>

            )}

      </CenterWrapper>
    );
  }





  // if (submitted) {
  //   let singleCountData = (countsData?.visitorCount || 0) + (countsData?.bookingCompleted || 0);
  //   return (
  //     <div id="scan-submitted-container">
  //       <div className="scan-card-success rounded" id="spot-saved-card">
  //         <div className="header-part" id="spot-saved-header">
  //           <span className="material-symbols-outlined" id="spot-saved-icon">check_circle</span>
  //           <h6 className="s-heading" id="spot-saved-title">SPOT SAVED</h6>
  //         </div>
  //         <div className="body-part" id="spot-saved-body">
  //           <span className="material-symbols-outlined" id="confirmation-number-icon">confirmation_number</span>
  //           <h2
  //             id="party-size-text"
  //             style={{
  //               fontSize: "1.2rem",
  //               fontWeight: "bold",
  //               textAlign: "center",
  //               margin: "10px 0"
  //             }}
  //           >
  //             PARTY OF{"  "}
  //             <span
  //               id="party-size-number"
  //               style={{
  //                 fontWeight: "bold",
  //                 color: "#000"
  //               }}
  //             >
  //               {scanCount}{" "}
  //               <span
  //                 style={{
  //                   fontWeight: "bold",
  //                   fontSize: "1.2rem",
  //                   margin: "0 4px",
  //                   color: "#555"
  //                 }}
  //               >
  //                 of
  //               </span>{" "}
  //               {scannedData?.partySize}
  //             </span>
  //           </h2>

  //           <p className="checkout-txt" id="ready-checkout-text">Ready to Check-out</p>
  //         </div>
  //       </div>
  //       <div className="col-md-12" id="action-buttons-container">
  //         <div className="card" id="action-buttons-card">
  //           <div className="card-body" id="action-buttons-body">
  //             <div className="d-flex justify-content-center align-items-center" id="action-buttons-flex">
  //               <button
  //                 id="scan-again-button"
  //                 className="stroke-btn-style me-3"
  //                 onClick={scanAgain}
  //               >
  //                 SCAN AGAIN
  //               </button>
  //               <button
  //                 id="check-out-button"
  //                 className="fill-btn-style"
  //                 onClick={() => checkInAPI(scannedData, 'checkOut')}
  //               >
  //                 {isLoading ? (
  //                   <img
  //                     src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
  //                     className="loading-icon"
  //                     alt="Loading"
  //                     id="scan-loading-icon"
  //                   />
  //                 ) : null}
  //                 CHECK OUT
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (submitted) {
    return (
      <CenterWrapper>

        <div className="card full-height-card">
          <div className="card-body success-card text-center px-0">

            <div className="spot-header justify-content-center">
              <div className="d-flex flex-column align-items-center gap-2">
                <span className="material-symbols-outlined text-success fs-1">
                  check_circle
                </span>

                <h5 className="mt-2">Visitor In Location</h5>

                <h4
                  id="party-size-text"
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    margin: "10px 0"
                  }}
                >
                  PARTY OF{"  "}
                  <span
                    id="party-size-number"
                    style={{
                      fontWeight: "bold",
                      color: "#000"
                    }}
                  >
                    {scanCount}{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                        margin: "0 4px",
                        color: "#555"
                      }}
                    >
                      of
                    </span>{" "}
                    {scannedData?.partySize}
                  </span>
                </h4>

                <div className="time-chip mt-2">
                  {moment(scannedData?.bookingDate).format("MMM DD, YYYY")}
                  <span className="date-chip">{scannedData?.spotstart}</span>
                </div>
              </div>
            </div>
            <div className="ticket-divider"><span /></div>
            {/* VISITOR */}
            <div class="visitor-section pt-0">
              <div class="d-flex gap-3 align-items-center">
                <span class="material-symbols-outlined avatar">account_circle</span>
                <div className='text-left'>
                  <h6 class="section-title">VISITOR</h6>
                  <p class="visitor-name">{scannedData?.guests?.[0]?.name || scannedData?.name}</p>
                </div>
              </div>
            </div>
            {/* Tags */}
            {/* <div className="tag-card">
              <h2 className="badge vip">VIP</h2>
              <p>High-value guest who receives priority treatment</p>
            </div> */}

            {/* <p className="checkout-txt">Ready to Check-out</p> */}

            <div className="d-flex justify-content-center gap-3 mt-4">
              <button className="stroke-btn-style" onClick={scanAgain}>
                SCAN NEXT VISITOR
              </button>

              {/* <button
                className="fill-btn-style"
                onClick={() => checkInAPI(scannedData, "checkOut")}
              >
                {isLoading && (
                  <img
                    src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"
                    className="loading-icon"
                  />
                )}
                CHECK OUT
              </button> */}
            </div>

          </div>
        </div>

      </CenterWrapper>
    );
  }




  return (
    <div id="scan-video-container">

      <div id="video-wrapper">
        {cameraBlocked && (
          <div className="camera-blocked-panel" id="scan-camera-blocked">
            <p className="camera-blocked-text" id="scan-camera-blocked-text">
              {scanErrorMsg}
            </p>
            <button
              type="button"
              className="fill-btn-style"
              id="scan-camera-retry-button"
              onClick={() => {
                scanned.current = false;
                startScanner();
              }}
            >
              TRY AGAIN
            </button>
          </div>
        )}
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          style={{ width: '100%', display: cameraBlocked ? 'none' : 'block' }}
          id="scan-video"
        />
        <canvas ref={canvasRef} style={{ display: 'none' }} id="scan-canvas" />
      </div>


      <SweetAlert
        show={tableErrMsg}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={"Please select store."}
        onConfirm={() => {
          setTableErrMsg(false);
          scanned.current = false;
          startScanner();
          onScanChange(false);
        }}
        id="alert-select-store"
      />

      <SweetAlert
        show={tableErrMsg1}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={"Invalid Scanner. The code you scanned is a different store"}
        onConfirm={() => {
          setTableErrMsg1(false);
          scanned.current = false;
          startScanner();
          onScanChange(false);
        }}
        id="alert-invalid-scanner"
      />

      <SweetAlert
        show={invalidBarcode}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={"Invalid bar code you scanned"}
        onConfirm={() => {
          setInvalidBarcode(false);
          scanned.current = false;
          startScanner();
        }}
        id="alert-invalid-barcode"
      />

      {/* OK only dismisses. Retrying startScanner() here re-threw the same error
          immediately (a denial is remembered by the browser), which re-opened this
          alert and locked the page. Retry is the button in the inline panel instead. */}
      <SweetAlert
        show={scanError}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={scanErrorMsg}
        onConfirm={() => {
          setScanError(false);
        }}
        id="alert-scan-error"
      />
    </div>
  );

};

export default ScannerComponent;

